export function parseHistoryPage(value: unknown): number {
  const page = typeof value === 'string' || typeof value === 'number' ? Number(value) : NaN
  return Number.isSafeInteger(page) && page > 0 ? page : 1
}
